import { render, staticRenderFns } from "./MarketTurntableItem.vue?vue&type=template&id=2c337bd2&scoped=true&"
import script from "./MarketTurntableItem.vue?vue&type=script&lang=js&"
export * from "./MarketTurntableItem.vue?vue&type=script&lang=js&"
import style0 from "./MarketTurntableItem.vue?vue&type=style&index=0&id=2c337bd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c337bd2",
  null
  
)

export default component.exports